import { Typography } from "@mindlercare/ui-web";
import { useAuth } from "../AuthenticationProvider";
import { useTranslation } from "../hooks/useTranslation";

export const UnableToLogin = () => {
  const { t } = useTranslation();
  const { userId } = useAuth();

  return (
    <div>
      <Typography variant="h3">{t("UNABLE_TO_LOGIN")}</Typography>
      <Typography variant="body-small">{t("MISSING_ROLES")}</Typography>
      {!!userId && (
        <Typography
          sx={{ marginTop: 32, display: "block" }}
          variant="body-bold"
        >
          {t("NAME_USER_ID")} {userId}
        </Typography>
      )}
    </div>
  );
};
